import {Injectable} from '@angular/core';
import {Cart} from '../../shopping-cart/Cart';
import {CartWithLineItems} from '../../shopping-cart/cart.service';
import {OrderSearchCriteria} from '../order-search/order-search.component';

@Injectable({
  providedIn: 'root'
})
export class SearchHistoryService {

  search(criteria: OrderSearchCriteria, carts: ReadonlyArray<CartWithLineItems>) {
    const startDate = criteria.beginDate ? new Date(criteria.beginDate) : null;
    const endDate = criteria.endDate ? new Date(criteria.endDate) : null;
    if (endDate) {
      endDate.setUTCHours(23, 59, 59, 999);
    }
    return carts.filter(cwi => {
      return this.searchDatesMatches(startDate, endDate, cwi.cart) && this.searchQueryMatches(criteria, cwi);
    });
  }

  private searchDatesMatches(start: Date | null, end: Date | null, cart: Cart): boolean {
    const statusDate = new Date(cart.statusDate);
    return (!start || statusDate >= start) && (!end || statusDate <= end);
  }

  private searchQueryMatches(criteria: OrderSearchCriteria, cwi: CartWithLineItems): boolean {
    return !criteria.query ||
      !!cwi.lineItems.find(li =>
        (criteria.searchFor.includeProductName ? li.product.title.toLowerCase().includes(criteria.query.toLowerCase()) : false) ||
        (criteria.searchFor.includeOrderNumber ? li.cart.id.toString().includes(criteria.query) : false) ||
        (criteria.searchFor.includeOrgId && li.cart.deptId != null ? li.cart.deptId.toLowerCase().includes(criteria.query) : false)
      );
  }

}
